import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deleteAIConfigSchema = z.object({ id: z.string() });

export const deleteAIConfig = mutator({
  schema: deleteAIConfigSchema,
  resolve: {
    provider: { kind: "aiProvider", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  // Any connected_app_usages row is purged by the AFTER DELETE trigger on
  // ai_providers (the triggers own the ref_id cascade).
  fn: async ({ tx, ctx, args: { provider } }) => {
    if (provider.active) {
      const [tenant] = await tx.run(zql.tenants.where("id", ctx.tenantId));
      if (
        tenant?.managedAiProviderLocked ||
        tenant?.managedAiProviderDisabledAt != null
      ) {
        throw userFacingError(
          "Set another AI provider as the default before deleting this one"
        );
      }
    }
    await tx.mutate.aiProviders.delete({ id: provider.id });
  },
});
